import React, { Fragment, useEffect, useState } from 'react';
import "./glitch.css";
import { useNavigate } from 'react-router-dom';

function Glitch() {
    const [blackPage, setBlackPage] = useState("hidden"); // Track loading state for images
    const [animationPage, setAnimationPage] = useState("visible"); // Track loading state for images

    useEffect(() => {
        const timer = setTimeout(() => {
            setBlackPage("visible")
            setAnimationPage("hidden")
        }, 5500);


        return () => clearTimeout(timer);
    }, []); 

    const navigate = useNavigate();


    useEffect(() => {
      const timer = setTimeout(() => {
        navigate('/home'); // Replace '/target-route' with your desired route path
      }, 5500); // 3000 milliseconds = 3 seconds
  
      // Cleanup the timer when the component unmounts
      return () => clearTimeout(timer);
    }, [navigate]);

    const myImage = 'https://i.ibb.co/6RcYJZD/screencapture-localhost-3000-2024-11-07-05-53-44-1.jpg';
    const blackImg = 'https://i.ibb.co/QKQyLqW/image.png';

    return (
        <Fragment>
        <main className={animationPage}>
            <div
                className="c-glitch"
                style={{ backgroundImage: `url(${myImage})` }}
            >
                <div
                    className="c-glitch__img"
                    style={{ backgroundImage: `url(${myImage})` }}
                ></div>
                <div
                    className="c-glitch__img"
                    style={{ backgroundImage: `url(${myImage})` }}
                ></div>
                <div
                    className="c-glitch__img"
                    style={{ backgroundImage: `url(${myImage})` }}
                ></div>
                <div
                    className="c-glitch__img"
                    style={{ backgroundImage: `url(${myImage})` }}
                ></div>
                <div
                    className="c-glitch__img"
                    style={{ backgroundImage: `url(${myImage})` }}
                ></div>
                {/* Add two more divs for the additional animations */}
                <div
                    className="c-glitch__img"
                    style={{ backgroundImage: `url(${myImage})` }}
                ></div>
                <div
                    className="c-glitch__img"
                    style={{ backgroundImage: `url(${myImage})` }}
                ></div>
 <div
                    className="c-glitch__img"
                    style={{ backgroundImage: `url(${blackImg})` }}
                ></div>

            </div>
        
        </main>
        </Fragment>
    );
}

export default Glitch;



// import React from 'react';
// import "./glitch.css"
// function Glitch() {
//     const myImage = 'https://i.ibb.co/QmMSrxq/glitch.png';

//     return (
//         <main>
//         <div
//           className="c-glitch"
//           style={{ backgroundImage: `url(${myImage})` }}
//         >
//           <div
//             className="c-glitch__img"
//             style={{ backgroundImage: `url(${myImage})` }}

//           ></div>
//           <div
//             className="c-glitch__img"
//             style={{ backgroundImage: `url(${myImage})` }}

//           ></div>
//           <div
//             className="c-glitch__img"
//             style={{ backgroundImage: `url(${myImage})` }}

//           ></div>
//           <div
//             className="c-glitch__img"
//             style={{ backgroundImage: `url(${myImage})` }}

//           ></div>
//           <div
//             className="c-glitch__img"
//             style={{ backgroundImage: `url(${myImage})` }}

//           ></div>
//         </div>
  
  
//       </main>
//     );
// }

// export default Glitch;
